/**
 * The one Supabase client of the CRM. Import it only from data hooks (`use…` in a .ts
 * file), never from a component: one hook per query or mutation (CLAUDE.md).
 *
 * Configured by web/.env.local (written by `npm run db:up` for the local stack):
 *   VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY — public values. The service-role key is
 *   refused by createGymClient and must never be put here.
 */
import { createGymClient } from '@gymcoach/shared';

export const supabase = createGymClient(
  import.meta.env.VITE_SUPABASE_URL as string | undefined,
  import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // Invite links carry their token in the #fragment for the set-password page;
      // nothing else in the CRM signs in through the URL.
      detectSessionInUrl: false,
      storageKey: 'gymcoach.crm.auth',
    },
    // postgrest-js retries a failed GET itself (3 more tries after 1 s, 2 s, 4 s), on top of
    // React Query's own retry: with no connection that kept "Loading" up for ~15 s. React
    // Query owns retries (lib/queryClient.ts), so the offline state shows in about a second.
    db: { retry: false },
  },
);

/** Domain for a phone-only member's synthetic sign-in email (never shown). */
export const PHONE_EMAIL_DOMAIN: string =
  (import.meta.env.VITE_PHONE_EMAIL_DOMAIN as string | undefined) ?? 'gymcoach.test';
